<template>
  <div>
    <div class="col-xl-2 col-md-2">
      <vs-input icon="search" label="Búsqueda" class="inputx" placeholder="Buscar..." v-model="search"/>
    </div>
    <table v-if="!dataFilter" class="table">
      <thead>
        <slot name="columns">
          <tr>
            <th v-for="column in columns" :key="column">{{column}}</th>
            <th>Opciones</th>
          </tr>
        </slot>
      </thead>
      <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
          <td v-for="column in columns" :key="column" v-if="hasValue(item, column)">{{itemValue(item, column)}}</td>
          <td>
              <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentEdit(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-settings-gear-64"></i></button>
              <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentDelete(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-simple-remove"></i></button>
          </td>
        </slot>
      </tr>
      </tbody>
    </table>
    <table v-else class="table">
      <thead>
        <slot name="columns">
          <tr>
            <th v-for="column in columns" :key="column">{{column}}</th>
            <th>Opciones</th>
          </tr>
        </slot>
      </thead>
      <tbody>
      <tr v-for="(item, index) in dataFilter" :key="index">
        <slot :row="item">
          <td v-for="column in columns" :key="column" v-if="hasValue(item, column)">{{itemValue(item, column)}}</td>
          <td>
              <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentEdit(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-settings-gear-64"></i></button>
              <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                  aria-expanded="false" aria-label="Toggle navigation" @click="functionComponentDelete(item)">
                  <i style="color: #0d6efd;" class="nc-icon nc-simple-remove"></i></button>
          </td>
        </slot>
      </tr>
      </tbody>
    </table>
  </div>
  
</template>
<script>
  export default {
    data() {
      return {
        search:'',
        dataFilter:'',
      }
    },
    name: 'l-table',
    props: {
      columns: Array,
      data: Array
    },
    watch: {
      search: function(val){
        if(val!=null && val!='' && val!=undefined){
          this.filtrarItems();
        } else{
          this.dataFilter=null;
        }
				
			},
    },
    computed: {
      
    },
    methods: {
      filtrarItems() {
        if(this.columns[1]=='Nombre'){
          this.dataFilter=this.data.filter(item =>
            item.nombre.toLowerCase().includes(this.search.toLowerCase())
          );
        }
        if(this.columns[1]=='Cuenta'){
          this.dataFilter=this.data.filter(item =>
            item.cuenta.includes(this.search)
          );
        }
        
      },
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      },
      functionComponentDelete(item){
        this.$emit('functionComponentDelete', item);
      },
      functionComponentEdit(item){
        this.$emit('functionComponentEdit', item);
      },
    }
  }
</script>
<style>
</style>
